var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AuthMethodScope } from '@lit-protocol/constants';
import { useSession } from '@/contexts/LitSessionProvider';
import { SESSION_LENGTHS } from './useLitSession';
import { getMFAActionId, getMFASessionSig } from '@/lib/auth/mfa';
import { getPKPSessionSig } from '@/lib/auth/sessionSig';
import { getLitContractClient } from '@/lib/auth/litContract';
import { AddPermittedAuthMethod } from '@/lib/auth/permittedAuthMethod';
import { AddPermittedAction, RemovePermittedAction } from '@/lib/auth/permittedAction';
import { AddPermittedAuthMethodScope } from '@/lib/auth/permittedAuthMethodScope';
import { getAuthId } from '@/lib/auth/getAuthId';
export default function useMFAUtilities(_a) {
    var _this = this;
    var _b = _a === void 0 ? {} : _a, setLoading = _b.setLoading, setError = _b.setError;
    var _c = useSession(), clients = _c.clients, sessionLength = _c.sessionLength, setLitSession = _c.setLitSession, MFAInfo = _c.MFAInfo, setMFAInfo = _c.setMFAInfo, PKP = _c.PKP, litSession = _c.litSession, currentAuthMethod = _c.currentAuthMethod;
    var ToggleMFA = function (authOverride, providerValue) { return __awaiter(_this, void 0, Promise, function () {
        var litContractClient, permittedAuthMethods, authId_1, isAuthIdPermitted, mfaActionId, permittedActions, result, data_1, _MFASessionSig_1, result, data, mfaActionId, sessionSigs, err_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 26, 27, 28]);
                    if (!(authOverride || (MFAInfo === null || MFAInfo === void 0 ? void 0 : MFAInfo.authMethod))) {
                        throw new Error('No MFA auth method provided');
                    }
                    if (!authOverride) return [3 /*break*/, 17];
                    console.log('Start addMFA');
                    return [4 /*yield*/, getLitContractClient(PKP.publicKey, litSession)];
                case 2:
                    litContractClient = _b.sent();
                    return [4 /*yield*/, litContractClient.pkpPermissionsContract.read.getPermittedAuthMethods(PKP.tokenId)];
                case 3:
                    permittedAuthMethods = _b.sent();
                    return [4 /*yield*/, getAuthId(authOverride, PKP, litSession)];
                case 4:
                    authId_1 = _b.sent();
                    console.log('MFAInfoInToggle', MFAInfo, authOverride);
                    isAuthIdPermitted = permittedAuthMethods.filter(function (permittedAuthMethod) {
                        var _a;
                        return parseInt((_a = permittedAuthMethod.authMethodType) === null || _a === void 0 ? void 0 : _a.toString()) ==
                            authOverride.authMethodType && permittedAuthMethod.id == authId_1;
                    });
                    if (!(isAuthIdPermitted.length == 0)) return [3 /*break*/, 6];
                    return [4 /*yield*/, AddPermittedAuthMethod(PKP, litSession, authOverride, [
                            AuthMethodScope.PersonalSign,
                        ])];
                case 5:
                    _b.sent();
                    _b.label = 6;
                case 6: return [4 /*yield*/, getMFAActionId(PKP, litSession)];
                case 7:
                    mfaActionId = _b.sent();
                    return [4 /*yield*/, litContractClient.pkpPermissionsContract.read.getPermittedActions(PKP.tokenId)];
                case 8:
                    permittedActions = _b.sent();
                    if (!!(permittedActions === null || permittedActions === void 0 ? void 0 : permittedActions.includes(mfaActionId))) return [3 /*break*/, 10];
                    return [4 /*yield*/, AddPermittedAction(PKP, litSession, mfaActionId, [
                            AuthMethodScope.SignAnything,
                            AuthMethodScope.PersonalSign,
                        ])];
                case 9:
                    _b.sent();
                    _b.label = 10;
                case 10:
                    if (!((MFAInfo === null || MFAInfo === void 0 ? void 0 : MFAInfo.scopes) && ((_a = MFAInfo === null || MFAInfo === void 0 ? void 0 : MFAInfo.scopes) === null || _a === void 0 ? void 0 : _a[2]) === false)) return [3 /*break*/, 12];
                    return [4 /*yield*/, AddPermittedAuthMethodScope(PKP, litSession, currentAuthMethod, [
                            AuthMethodScope.PersonalSign,
                        ])];
                case 11:
                    _b.sent();
                    _b.label = 12;
                case 12: return [4 /*yield*/, fetch('/api/auth/mfa-info', {
                        method: 'POST',
                        body: JSON.stringify({
                            dataToSave: {
                                authMethodType: authOverride.authMethodType,
                                authId: authId_1,
                                providerValue: providerValue,
                            },
                        }),
                    })];
                case 13:
                    result = _b.sent();
                    return [4 /*yield*/, result.json()];
                case 14:
                    data_1 = _b.sent();
                    if (!(data_1 === null || data_1 === void 0 ? void 0 : data_1.mfaInfo)) return [3 /*break*/, 16];
                    setMFAInfo(function (prev) { return (__assign(__assign({}, prev), { providerValue: providerValue, authMethod: authOverride, scopes: [false, true, true], presentMFAInfo: {
                            authMethodType: data_1.mfaInfo.auth_method_type,
                            authId: data_1.mfaInfo.auth_id,
                        } })); });
                    return [4 /*yield*/, getMFASessionSig(PKP, currentAuthMethod, authOverride, clients.litNodeClient, sessionLength || SESSION_LENGTHS['1 week'], litSession)];
                case 15:
                    _MFASessionSig_1 = _b.sent();
                    console.log('_MFASessionSig', _MFASessionSig_1);
                    setLitSession(_MFASessionSig_1);
                    setMFAInfo(function (prev) { return (__assign(__assign({}, prev), { MFALoggedIn: true, sessionSigs: _MFASessionSig_1 })); });
                    _b.label = 16;
                case 16:
                    console.log('End addMFA');
                    return [3 /*break*/, 25];
                case 17:
                    console.log('Start removeMFA');
                    setMFAInfo(function (prev) { return (__assign(__assign({}, prev), { authMethod: null, providerValue: null })); });
                    return [4 /*yield*/, AddPermittedAuthMethodScope(PKP, litSession, currentAuthMethod, [
                            AuthMethodScope.SignAnything,
                        ])];
                case 18:
                    _b.sent();
                    return [4 /*yield*/, fetch('/api/auth/mfa-info', {
                            method: 'POST',
                            body: JSON.stringify({
                                dataToSave: {
                                    authMethodType: null,
                                    authId: null,
                                    providerValue: null,
                                },
                            }),
                        })];
                case 19:
                    result = _b.sent();
                    return [4 /*yield*/, result.json()];
                case 20:
                    data = _b.sent();
                    if (!(data === null || data === void 0 ? void 0 : data.mfaInfo)) return [3 /*break*/, 24];
                    return [4 /*yield*/, getMFAActionId(PKP, litSession)];
                case 21:
                    mfaActionId = _b.sent();
                    return [4 /*yield*/, RemovePermittedAction(PKP, litSession, mfaActionId)];
                case 22:
                    _b.sent();
                    setMFAInfo(function (prev) { return (__assign(__assign({}, prev), { presentMFAInfo: null, sessionSigs: null })); });
                    return [4 /*yield*/, getPKPSessionSig(PKP, currentAuthMethod, clients.litNodeClient, sessionLength || SESSION_LENGTHS['1 week'])];
                case 23:
                    sessionSigs = _b.sent();
                    setLitSession(sessionSigs);
                    setMFAInfo(function (prev) { return (__assign(__assign({}, prev), { MFALoggedIn: false })); });
                    _b.label = 24;
                case 24:
                    console.log('End removeMFA');
                    _b.label = 25;
                case 25:
                    setError(null);
                    setLoading(false);
                    return [2 /*return*/, {
                            success: true,
                        }];
                case 26:
                    err_1 = _b.sent();
                    console.error('[ToggleMFA]', err_1);
                    setError(err_1.message);
                    setLoading(false);
                    return [2 /*return*/, {
                            success: false,
                            error: err_1.message,
                        }];
                case 27:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 28: return [2 /*return*/];
            }
        });
    }); };
    return { ToggleMFA: ToggleMFA };
}
